var React = require('react');

function GalleryNextButtonMobile (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 41L13 21L1 0.999999","stroke":"#F3F3F3","strokeWidth":"2","strokeLinecap":"round"}));
}

GalleryNextButtonMobile.defaultProps = {"width":"15","height":"32","viewBox":"0 0 15 42","fill":"none"};

module.exports = GalleryNextButtonMobile;

GalleryNextButtonMobile.default = GalleryNextButtonMobile;
